/* eslint-disable import/extensions */
import Vue from 'vue'
import VueRouter from 'vue-router'
import company from './groups/company'
import users from './groups/users'
import common from './groups/common'
import jobSetting from './groups/job-setting'
import crm from './groups/crm'
import adminSettings from './groups/admin-settings'
import projectManagement from './groups/project-management'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    ...company,
    ...users,
    ...common,
    ...jobSetting,
    ...crm,
    ...adminSettings,
    ...projectManagement,
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('wz-loading-bg')

  if (appLoading) {
    appLoading.classList.add('d-none')
  }
})

// checks for next middleware
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index]
  if (!subsequentMiddleware) return context.next

  return (...parameters) => {
    context.next(...parameters)
    const nextMiddleware = nextFactory(context, middleware, index + 1)
    subsequentMiddleware({ ...context, next: nextMiddleware })
  }
}

// checks for middlewares
router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware]
    const context = {
      from,
      next,
      router,
      to,
    }
    const nextMiddleware = nextFactory(context, middleware, 1)
    return middleware[0]({ ...context, next: nextMiddleware })
  }
  return next()
})

export default router
